define.alias("shared/components/shared/post/secondary/hashtag-suggestions/empty", "calendar/components/shared/post/secondary/hashtag-suggestions/empty");